export default {
    RANK_MORE_THAN_100: 101,
    KEYWORD_MIN_CHARS: 2,
};
